import { render } from "./chartWordCloudStyle.vue?vue&type=template&id=6d8bd21e"
import script from "./chartWordCloudStyle.vue?vue&type=script&lang=js"
export * from "./chartWordCloudStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__